angular.module('bribac.services.saveBlobAsFile', [])

  .factory('saveBlobAsFile', function(
    $window,
    $timeout
  ) {
    return function saveBlobAsFile(blob, fileName) {
      var document = $window.document
      var ua = $window.navigator.userAgent

      var ie = ua.match(/MSIE\s([\d.]+)/)
      var ie11 = ua.match(/Trident\/7.0/) && ua.match(/rv:11/)
      var ieEDGE = ua.match(/Edge/g)
      var ieVer = (ie ? ie[1] : (ie11 ? 11 : (ieEDGE ? 12 : -1)))

      if (ie && ieVer < 10) {
        if (console && console.error) {
          console.error("Can't download because Blobs are not supported on Internet Explorer 10 and older versions.");
        }
        return;
      }

      if (ieVer > -1) {
        $window.navigator.msSaveBlob(blob, fileName);
      } else {
        var objectUrl = $window.URL.createObjectURL(blob)
        var link = document.createElement('a')
        link.download = fileName
        link.href = objectUrl
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        $timeout(function() {
          if (link.parentNode) link.parentNode.removeChild(link)
          $window.URL.revokeObjectURL(objectUrl)
        }, 100)
      }
    }
  })
